/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCoachClientRequest } from '../models/CreateCoachClientRequest';
import type { UpdateCoachClientTagsRequest } from '../models/UpdateCoachClientTagsRequest';
import type { V4CoachClient } from '../models/V4CoachClient';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CoachClientsV4Service {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create Coach Client
     * Creates a coach-client access record for a tenant
     * @param userId
     * @param requestBody
     * @returns V4CoachClient Success
     * @throws ApiError
     */
    public createCoachClient(
        userId: string,
        requestBody: CreateCoachClientRequest,
    ): CancelablePromise<V4CoachClient> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v4/coaches/{userId}/clients',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update Coach Client Tags
     * Updates the clientTags for a coach-client access record
     * @param userId
     * @param tenantId
     * @param requestBody
     * @returns V4CoachClient Success
     * @throws ApiError
     */
    public updateCoachClientTags(
        userId: string,
        tenantId: string,
        requestBody: UpdateCoachClientTagsRequest,
    ): CancelablePromise<V4CoachClient> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v4/coaches/{userId}/clients/{tenantId}',
            path: {
                'userId': userId,
                'tenantId': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete Coach Client
     * Deletes a coach-client access record
     * @param userId
     * @param tenantId
     * @returns void
     * @throws ApiError
     */
    public deleteCoachClient(
        userId: string,
        tenantId: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v4/coaches/{userId}/clients/{tenantId}',
            path: {
                'userId': userId,
                'tenantId': tenantId,
            },
        });
    }

}
